import { EntityName } from 'record-it-time-common/EntityName';
import { ConstructionSite } from '../../../classes/entities/ConstructionSite/constructionSiteTypes';
import { useEntityDeleteHandler } from './useEntityDeleteHandler';

export function useConstructionSiteDeleteHandler(
  constructionSite: ConstructionSite
): () => void {
  return useEntityDeleteHandler(
    EntityName.ConstructionSite,
    constructionSite,
    (site) => site.name
  );
}
